export const SUB_TITLE = '(Google Spreadsheet)';
export const OPEN_BTN = 'Open';
